// REST client for the account-settings authenticator-app (TOTP) 2FA endpoints
// (/api/authenticator_app): start setup (get a QR-ready secret), confirm it
// with a code from the app, or disable it and fall back to email codes.
import apiFetch from "../apiFetch";

const parseErrorMessage = async (response, fallback) => {
  const body = await response.json().catch(() => null);
  return body?.message || fallback;
};

export const getAuthenticatorAppStatus = async () => {
  const response = await apiFetch("/api/authenticator_app");
  if (!response.ok) {
    throw new Error(
      await parseErrorMessage(
        response,
        "Failed to load authenticator app status."
      )
    );
  }
  return response.json();
};

export const setupAuthenticatorApp = async () => {
  const response = await apiFetch("/api/authenticator_app/setup", {
    method: "POST",
  });
  if (!response.ok) {
    throw new Error(
      await parseErrorMessage(
        response,
        "Failed to start authenticator app setup."
      )
    );
  }
  return response.json();
};

export const confirmAuthenticatorApp = async (code) => {
  const response = await apiFetch("/api/authenticator_app/confirm", {
    method: "POST",
    body: JSON.stringify({ code }),
  });
  if (!response.ok) {
    throw new Error(
      await parseErrorMessage(response, "Incorrect code. Please try again.")
    );
  }
  return response.json();
};

export const disableAuthenticatorApp = async () => {
  const response = await apiFetch("/api/authenticator_app", {
    method: "DELETE",
  });
  if (!response.ok) {
    throw new Error(
      await parseErrorMessage(response, "Failed to disable authenticator app.")
    );
  }
};

export const regenerateBackupCodes = async () => {
  const response = await apiFetch(
    "/api/authenticator_app/backup_codes/regenerate",
    {
      method: "POST",
    }
  );
  if (!response.ok) {
    throw new Error(
      await parseErrorMessage(response, "Failed to regenerate backup codes.")
    );
  }
  return response.json();
};
